export const checkInAppBrowser = () => {
  if (typeof window === 'undefined') return false;
  const ua = navigator?.userAgent;
  if (!ua) return false;
  const inApp = new RegExp(
    /FB[\w_]|Messenger|MESSENGER|Instagram|Twitter|TikTok/g
  ).test(ua);
  return inApp;
};
